<template lang="pug">
div.Telegram-page(ref="TelegramPage")
  Telegram-chat-item.animate__animated.animate__fadeInUp(
    v-for="(item, index) in messages",
    :key="index",
    :name="item.name",
    :name-color="item.nameColor",
    :time="item.time",
    :reply="item.reply",
    :type="item.type",
    :text-content="item.text",
    :srcs="item.srcs"
  )
</template>

<script>
import TelegramChatItem from '@/components/TelegramChatItem'
import sleep from '@/utils/sleep'
import { clearAllBodyScrollLocks } from 'body-scroll-lock'

const PerfectScrollbar = window.PerfectScrollbar

const messages = [
  {
    name: '即韩',
    nameColor: '#E4C75F',
    type: 'text',
    text: '网警连电信诈骗、裸照敲诈勒索都管不过来。',
    time: '3:55 PM'
  },
  {
    name: 'SORR HYLN',
    nameColor: '#34D8A7',
    type: 'text',
    text: '顶多行政警告。',
    time: '3:57 PM'
  },
  {
    name: 'ELENA ELENA',
    nameColor: '#E779BB',
    type: 'text',
    text: '不攻击党和人民，不搞诈骗，不伸头给网警砍。',
    time: '4:12 PM'
  },
  {
    name: '大直男',
    nameColor: '#A155ED',
    type: 'text',
    text: '浏览，有错吗？',
    time: '4:25 PM'
  },
  {
    name: 'fi 狗',
    nameColor: '#20FFBC',
    type: 'text',
    text: '有没有反差婊，母狗，一起玩一玩？',
    time: '5:00 PM'
  }
]

export default {
  name: 'TelegramPage',
  components: {
    TelegramChatItem
  },
  data () {
    return {
      isActive: false,
      messages: [],
      index: 0
    }
  },
  methods: {
    async push () {
      this.messages.push(messages[this.index])
      await sleep(1000)
      if (this.isActive) {
        this.$refs.TelegramPage.scrollTop = this.$refs.TelegramPage.scrollHeight
      }
      if (this.index < messages.length - 1) {
        this.index++
        this.push()
      } else {
        clearAllBodyScrollLocks()
      }
    }
  },
  mounted () {
    this.isActive = true
    this.push()

    const ps = new PerfectScrollbar(this.$refs.TelegramPage, {
      suppressScrollX: true,
      useBothWheelAxes: true
    })
    ps.update()
  },
  beforeDestroy () {
    this.isActive = false
    this.messages = []

    clearAllBodyScrollLocks()
  }
}
</script>

<style scoped lang="scss">
.Telegram-page {
  height: 100%;
  overflow: hidden;
  color: #FFF;
}
</style>
